module.exports = __webpack_public_path__ + "static/media/menu-close.43a502cd.svg";